<template>
  <div :class="{show: openModal }"
       class="modal fade company-event-modal">
    <div class="modal-dialog modal-dialog-centered company-event-modal-dialog"
         :class="{
           'modal-dialog-scrollable': !isLegislated,
           'company-event-modal-dialog--legislated': isLegislated,
         }">
      <div class="modal-content">
        <div class="modal-header pb-0 no-border">
          <h3 class="mt-0 pt-1">{{ (modalAction==='add') ? $t("flexben.clients.modal.add") :
            $t("flexben.clients.modal.edit") }}
            {{ (type==='company_event') ? $t("flexben.clients.modal.event") :
            $t("flexben.clients.modal.occasion")}} </h3>
          <span :class="formData.is_active ? 'occasion-active' :'occasion-inactive'"
                class="occasion-active float-right">{{ formData.is_active ? $t("flexben.general.status_type.active") : $t("flexben.general.status_type.inactive") }}</span>
        </div>

        <div class="modal-body py-0 bg-white">
          <div class="row mt-2" v-if="Object.keys(errorBag).length > 0 && errorBag.constructor === Object">
            <div class="col-12">
              <FormErrorList :errorBag="errorBag"></FormErrorList>
            </div>
          </div>
          <div class="row pr-3">
            <div class="col-12 col-md-6 mb-2">
              <label for="event_name" class="w-100 cursor-pointer form-fields-required col-form-label">{{$t("flexben.general.name")}}</label>
              <input type="text" class="form-control w-100" id="event_name"
                     :class="{
                      'background-white':!isLegislated
                     }"
                     :disabled="isLegislated"
                     v-model="formData.name">
            </div>
            <div class="col-12 col-md-6">
              <label
                class="w-100 cursor-pointer form-fields-required col-form-label">{{$t("flexben.general.date")}}</label>
              <div class="row">
                <div class="col-md-7 mb-2">
                  <select name="month" id="month" v-model="date.month" class="form-control"
                          :disabled="formData.is_birthday || isLegislated"
                          :class="{' cursor-pointer':!formData.is_birthday}"
                          @change="function() {
                    tickDay++;
                  }">
                    <option value="" disabled>{{ $t('flexben.general.month') }}</option>
                    <option value="1">{{$t("flexben.general.months.1")}}</option>
                    <option value="2">{{$t("flexben.general.months.2")}}</option>
                    <option value="3">{{$t("flexben.general.months.3")}}</option>
                    <option value="4">{{$t("flexben.general.months.4")}}</option>
                    <option value="5">{{$t("flexben.general.months.5")}}</option>
                    <option value="6">{{$t("flexben.general.months.6")}}</option>
                    <option value="7">{{$t("flexben.general.months.7")}}</option>
                    <option value="8">{{$t("flexben.general.months.8")}}</option>
                    <option value="9">{{$t("flexben.general.months.9")}}</option>
                    <option value="10">{{$t("flexben.general.months.10")}}</option>
                    <option value="11">{{$t("flexben.general.months.11")}}</option>
                    <option value="12">{{$t("flexben.general.months.12")}}</option>
                  </select>
                </div>

                <div class="col-md-5 mb-2">
                  <select name="day" id="day" v-model="date.day"
                          :disabled="(date.month ==='' || formData.is_birthday || isLegislated)"
                          class="w-100 form-control"
                          :class="{' cursor-pointer':!(date.month ==='' || formData.is_birthday)}"
                          :key="tickDay">
                    <option value="" disabled>{{$t("flexben.general.day")}}</option>
                    <option :value="day" v-for="day in getMonthMaxDays()" :key="day">{{day}}</option>
                  </select>
                </div>

              </div>
            </div>
            <div class="col-12 col-md-6 mb-2">
              <label for="max_top_up" class="w-100 form-fields-required col-form-label">{{$t("flexben.general.top_up_limit")}}
                (Lei)</label>
              <input type="number" min="1" class="form-control w-100" id="max_top_up"
                     v-model.number="formData.maximum_topup_limit">
            </div>
            <div class="col-12 col-md-6 mb-2" v-if="type==='company_event'">
              <div class="w-100 mb-3 form-fields-required col-form-label">{{$t("flexben.clients.modal.birthday")}}</div>
              <div class="row">
                <div class="col-6 col-md-4">
                  <label for="birthday_yes" class="form-fields-required col-form-label">
                    <input type="radio"
                           name="birthday"
                           class="radio-custom cursor-pointer"
                           id="birthday_yes"
                           :value="true"
                           :disabled="isLegislated"
                           v-model="formData.is_birthday"/>
                    {{$t("flexben.general.yes")}}</label>
                </div>
                <div class="col-6 col-md-4">
                  <label for="birthday_no" class="col-form-label">
                    <input type="radio"
                           name="birthday"
                           class="radio-custom cursor-pointer"
                           id="birthday_no"
                           :value="false"
                           :disabled="isLegislated"
                           v-model="formData.is_birthday"/>
                    {{$t("flexben.general.no")}}</label>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mb-2" v-if="type==='company_event'">
              <div class="w-100 mb-3 col-form-label pb-0">{{ $t("flexben.clients.modal.gender_availability") }}
              </div>
              <div class="row">
                <div class="col-6 d-inline-flex">
                  <input type="checkbox" id="gender_men" class="cursor-pointer my-auto"
                         v-model="formData.gender_availability.male"
                         :disabled="isLegislated"/>
                  <label for="gender_men"
                         class="ml-2 mb-0 cursor-pointer col-form-label p-0">{{$t("flexben.clients.modal.gender_male")}}</label>
                </div>
                <div class="col-6 d-inline-flex">
                  <input type="checkbox" id="gender_women" class="cursor-pointer my-auto"
                         v-model="formData.gender_availability.female"
                         :disabled="isLegislated"/>
                  <label for="gender_women" class="ml-2 mb-0 cursor-pointer col-form-label p-0">{{$t("flexben.clients.modal.gender_female")}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 mb-2" v-if="formData.has_limit_per_child">
              <label for="max_limit_child" class="w-100 form-fields-required col-form-label">
                {{$t("flexben.clients.modal.max_limit_for_topup_per_child")}} (Lei)
              </label>
              <input type="number" min="1" class="form-control w-100" id="max_limit_child"
                     v-model.number="maximum_topup_limit_per_minor_value"
                     :max="formData.maximum_topup_limit">
            </div>
          </div>
          <div class="row mt-3 pt-3 border-top" v-if="isLegislated">
            <div class="col-12 mb-2">
              <span class="text-16 text-bold">{{ $t("flexben.clients.modal.platform_schedule_title") }}</span>
            </div>
            <div class="col-12 mb-2" v-if="overlapWarningText">
              <div class="alert alert-warning mb-0 py-2">
                <font-awesome-icon icon="exclamation-triangle" class="mr-1"/>
                {{ overlapWarningText }}
              </div>
            </div>
            <div class="col-12 col-md-6 mb-2">
              <label for="platform_open_date" class="w-100 col-form-label">
                {{ $t("flexben.clients.modal.platform_open_date") }}
              </label>
              <div class="d-inline-flex w-100">
                <font-awesome-icon icon="calendar-alt" class="my-auto mr-2 text-24 flx-calendar-icon"/>
                <datepicker
                  id="platform_open_date"
                  :format="dateFormat"
                  :inputClass="'form-control-d m-0 w-100 background-white'"
                  :calendar-class="'company-event-datepicker-calendar'"
                  class="w-100"
                  :disabled="!formData.is_active"
                  :disabledDates="eventValidityDisabledDates"
                  :open-date="eventCalendarOpenDate"
                  v-model="formData.platform_open_date"
                  @input="notifyScheduleTouched"
                />
              </div>
            </div>
            <div class="col-12 col-md-6 mb-2">
              <label for="platform_close_date" class="w-100 col-form-label">
                {{ $t("flexben.clients.modal.platform_close_date") }}
              </label>
              <div class="d-inline-flex w-100">
                <font-awesome-icon icon="calendar-alt" class="my-auto mr-2 text-24 flx-calendar-icon"/>
                <datepicker
                  id="platform_close_date"
                  :format="dateFormat"
                  :inputClass="'form-control-d m-0 w-100 background-white'"
                  :calendar-class="'company-event-datepicker-calendar'"
                  class="w-100"
                  :disabled="!formData.is_active"
                  :disabledDates="eventValidityDisabledDates"
                  :open-date="eventCalendarOpenDate"
                  v-model="formData.platform_close_date"
                  @input="notifyScheduleTouched"
                />
              </div>
            </div>
            <div class="col-12 mb-2">
              <button type="button"
                      class="btn text-themed px-0"
                      :disabled="!formData.is_active"
                      @click="resetPlatformSchedule">
                <font-awesome-icon icon="undo" class="mr-1"/>
                {{ $t("flexben.clients.modal.platform_schedule_reset") }}
              </button>
            </div>
          </div>
        </div>

        <div class="modal-footer no-border">
          <button type="button"
                  @click="toggleStatus()"
                  class="btn mr-auto text-themed">
            <font-awesome-icon icon="ban" v-if="formData.is_active" :key="'status_changer'"/>
            <font-awesome-icon icon="check" v-else :key="'status_changer'"/>
            {{ formData.is_active ? $t("flexben.clients.modal.set_inactive") : $t("flexben.clients.modal.set_active") }}
          </button>
          <button type="button"
                  @click="closeModal()"
                  class="btn text-themed">{{$t("flexben.general.btn.cancel")}}
          </button>
          <button type="button"
                  @click="submitForm()"
                  class="btn save-btn">{{$t("flexben.general.btn.save")}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormErrorList from "../../../fragments/FormErrorList";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

const EVENT_VALIDITY_DAYS_BEFORE = 30;
const EVENT_VALIDITY_DAYS_AFTER = 30;

export default {
  name: "CompanyEventModal",
  components: {FormErrorList, datepicker: Datepicker},
  props: {
    openModal: {
      type: Boolean,
      default: false,
      required: true
    },
    type: {
      type: String,
      default: '',
      required: true
    },
    formData: {
      type: Object,
      default: function () {
        return {
          occasionId: null,
          occasionIndex: null,
          name: '',
          is_active: true,
          maximum_topup_limit: 0,
          maximum_topup_limit_per_minor: 0,
          date: {
            day: null,
            month: null,
            year: null,
          },
          is_birthday: false,
          gender_availability: {
            male: true,
            female: true,
          },
        };
      },
      required: true
    },
    modalAction: null,
    errorBag: {
      type: Object,
      default: function () {
        return {};
      },
    },
    isLegislated: {
      type: Boolean,
      required: false,
      default: false
    },
    legislatedEvents: {
      type: Array,
      default: function () {
        return [];
      },
    },
    legalEventsCustomization: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      date: {
        day: '',
        month: '',
      },
      tickDay: 0,
      maximum_topup_limit_per_minor_value: null,
      dateFormat: 'dd/MM/yyyy',
    }
  },
  computed: {
    eventAnchorDate() {
      if (!this.formData.date || !this.formData.date.day || !this.formData.date.month) {
        return null;
      }
      let year = this.formData.date.year;
      if (!year) {
        const referenceDate = this.formData.platform_open_date || this.formData.platform_close_date;
        year = referenceDate ? moment(referenceDate).year() : moment().year();
      }
      return moment({
        year: year,
        month: parseInt(this.formData.date.month, 10) - 1,
        day: parseInt(this.formData.date.day, 10),
      }).startOf('day');
    },
    eventCalendarOpenDate() {
      return this.eventAnchorDate ? this.eventAnchorDate.toDate() : new Date();
    },
    eventValidityDisabledDates() {
      const eventDate = this.eventAnchorDate;
      if (!eventDate) {
        return {};
      }
      // vuejs-datepicker: disables date < to and date > from (bounds themselves stay enabled)
      const minDate = eventDate.clone().subtract(EVENT_VALIDITY_DAYS_BEFORE, 'days').startOf('day');
      const maxDate = eventDate.clone().add(EVENT_VALIDITY_DAYS_AFTER, 'days').startOf('day');
      return {
        to: minDate.toDate(),
        from: maxDate.toDate(),
      };
    },
    currentEventInterval() {
      if (!this.isLegislated || !this.formData.is_active || this.formData.is_birthday) {
        return null;
      }
      return this.resolveIntervalFromDates(
        this.eventAnchorDate,
        this.formData.platform_open_date,
        this.formData.platform_close_date
      );
    },
    overlappingEvents() {
      const currentInterval = this.currentEventInterval;
      if (!currentInterval || !this.legislatedEvents.length) {
        return [];
      }

      const currentId = this.formData.occasionId;
      return this.legislatedEvents.filter((event) => {
        if (!event || event.id === currentId || event.on_birthday) {
          return false;
        }
        const customization = this.legalEventsCustomization[event.id];
        if (!customization || !customization.is_active) {
          return false;
        }
        const otherInterval = this.resolveEventInterval(event, customization);
        if (!otherInterval) {
          return false;
        }
        return this.intervalsOverlap(currentInterval, otherInterval);
      });
    },
    overlapWarningText() {
      if (!this.overlappingEvents.length) {
        return '';
      }
      const names = this.overlappingEvents.map((event) =>
        this.$t('flexben.general.legal_events.' + event.name)
      ).join(', ');
      return this.$t('flexben.clients.modal.platform_schedule_overlap_warning', {events: names});
    },
  },
  watch: {
    date: {
      handler(val) {
        this.formData.date = {
          day: this.date.day,
          month: this.date.month,
          year: null,
        };
      },
      deep: true
    },
    maximum_topup_limit_per_minor_value: {
      handler(val) {
        if (val) {
          this.formData.maximum_topup_limit_per_minor = parseFloat(val);
        } else {
          this.formData.maximum_topup_limit_per_minor = null;
        }
      }
    }
  },
  created() {
    if (this.formData.date.month !== null && this.formData.date.day !== null) {
      this.date = {
        day: this.formData.date.day,
        month: this.formData.date.month,
      };
    }
    this.maximum_topup_limit_per_minor_value = this.formData.maximum_topup_limit_per_minor;
  },


  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
    submitForm() {
      this.$emit('submitForm');
    },
    toggleStatus() {
      this.$emit('toggleStatus');
    },
    resetPlatformSchedule() {
      if (!this.formData.is_active) {
        return;
      }
      this.$set(this.formData, 'platform_open_date', null);
      this.$set(this.formData, 'platform_close_date', null);
      this.$emit('scheduleTouched');
    },
    notifyScheduleTouched() {
      this.$emit('scheduleTouched');
    },
    resolveEventInterval(event, customization) {
      if (!event || !event.event_date || !event.event_date.day || !event.event_date.month) {
        return null;
      }
      const year = event.event_date.year || moment().year();
      const eventDate = moment({
        year: year,
        month: parseInt(event.event_date.month, 10) - 1,
        day: parseInt(event.event_date.day, 10),
      }).startOf('day');

      if (!eventDate.isValid()) {
        return null;
      }

      const openOffset = customization && customization.platform_open_offset_days != null
        ? customization.platform_open_offset_days
        : null;
      const closeOffset = customization && customization.platform_close_offset_days != null
        ? customization.platform_close_offset_days
        : null;

      if (openOffset != null && closeOffset != null) {
        return {
          start: eventDate.clone().add(openOffset, 'days').startOf('day'),
          end: eventDate.clone().add(closeOffset, 'days').endOf('day'),
        };
      }

      const openDate = customization && customization.platform_open_date
        ? moment(customization.platform_open_date, ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601], true)
        : null;
      const closeDate = customization && customization.platform_close_date
        ? moment(customization.platform_close_date, ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601], true)
        : null;

      if (openDate && openDate.isValid() && closeDate && closeDate.isValid()) {
        return {
          start: openDate.startOf('day'),
          end: closeDate.endOf('day'),
        };
      }

      return this.resolveIntervalFromDates(eventDate, null, null);
    },
    resolveIntervalFromDates(eventDate, openValue, closeValue) {
      if (!eventDate || !eventDate.isValid()) {
        return null;
      }

      const openDate = openValue ? moment(openValue).startOf('day') : null;
      const closeDate = closeValue ? moment(closeValue).startOf('day') : null;

      if (openDate && openDate.isValid() && closeDate && closeDate.isValid()) {
        return {
          start: openDate,
          end: closeDate.endOf('day'),
        };
      }

      return {
        start: eventDate.clone().subtract(EVENT_VALIDITY_DAYS_BEFORE, 'days').startOf('day'),
        end: eventDate.clone().add(EVENT_VALIDITY_DAYS_AFTER, 'days').endOf('day'),
      };
    },
    intervalsOverlap(first, second) {
      return first.start.isSameOrBefore(second.end) && second.start.isSameOrBefore(first.end);
    },
    getMonthMaxDays() {
      if (this.date.month === '') {
        return 0;
      } else {
        let days = [];
        let month = this.date.month;
        let maxDays = (new Date((new Date()).getFullYear(), month, 0)).getDate();
        for (let nr = 1; nr <= maxDays; nr++) {
          days.push(nr);
        }
        return days;
      }
    }
  }
}
</script>
<style scoped>
.form-control {
  margin: 0 !important;
  border: 1px solid #ced4da;
  padding: 0 5px;
  height: 36px !important;
}

.form-control:focus {
  outline: none;
  box-shadow: none;
}

.company-event-modal-dialog--legislated >>> .modal-content,
.company-event-modal-dialog--legislated >>> .modal-body {
  overflow: visible !important;
}

.company-event-modal-dialog--legislated >>> .vdp-datepicker {
  position: relative;
  z-index: 1;
}

.company-event-modal-dialog--legislated >>> .company-event-datepicker-calendar.vdp-datepicker__calendar {
  top: auto !important;
  bottom: 100%;
  margin-bottom: 4px;
  z-index: 31000 !important;
}
</style>
